import React from 'react';

export interface HubErrorReport {
	error: Error;
	/** What failed: `hub-page`, `banner`, or an extension key. */
	id: string;
	packageName: string;
	shouldForceError?: boolean;
}

export type HubErrorObserver = (report: HubErrorReport) => void;

/**
 * Optional hook for a host product to observe hub failures, for example to feed a
 * reliability metric.
 *
 * Purely observational: `HubErrorBoundary` behaves identically whether or not a host
 * provides one, and only reportable errors are forwarded (4xx are skipped).
 */
export const HubErrorObserverContext: React.Context<HubErrorObserver | undefined> =
	React.createContext<HubErrorObserver | undefined>(undefined);
